'use client';

import { Flex } from '@chakra-ui/react';

import { IntroductionSection } from './components/IntroductionSection';

interface Props {
  content: RegisterNetworkPageContent;
}

export type RegisterNetworkPageProps = Props;

const RegisterNetworkPage = () => {
  return (
    <Flex direction="column" w="full">
      <IntroductionSection />
    </Flex>
  );
};

export default RegisterNetworkPage;
